import { makeStyles } from '@material-ui/core/styles';

import { COLORS } from 'src/data/ui';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'column nowrap',

      '& $label + $subtitle': {
        marginTop: theme.spacing(0.5),
      },
    },

    header: {
      position: 'relative',
      marginBottom: 10,
      minHeight: 12,
    },
    empty: {
      display: 'none',
    },
    label: {},
    labelBold: {
      fontWeight: theme.typography.fontWeightMedium,
    },
    subtitle: {
      marginTop: theme.spacing(1),
      color: COLORS.neutral.mediumGray,
      letterSpacing: 'normal',
    },
    helperText: {
      lineHeight: theme.typography.pxToRem(16),
      color: COLORS.gray.gray40,
      marginTop: theme.spacing(0.5),
      marginLeft: 1,
    },
    textCounter: {
      position: 'absolute',
      bottom: '0',
      right: '0',

      ...theme.typography.regular14,
      color: COLORS.gray.gray50,
      letterSpacing: 'normal',
    },

    inputWrapper: {
      display: 'flex',
      flexFlow: 'row nowrap',
      alignItems: 'center',
    },
    input_root: () => ({
      width: '100%',

      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
      borderRadius: theme.shape.borderRadiusMedium,
    }),
    disableAutofillStyle: {
      '& :-webkit-autofill': {
        '-webkit-background-color': COLORS.neutral.white,
        '-webkit-transition-delay': '9999999s',
      },
    },
    inputMultiline: {},
    error: {
      marginTop: theme.spacing(0.5),
    },
    processing: {
      display: 'flex',
      marginRight: '-5px',
      paddingLeft: 8,
    },
    words: {
      position: 'absolute',
      right: 0,
      bottom: 0,
      lineHeight: theme.typography.pxToRem(12),
      color: theme.palette.text.secondary,
    },
    endAdornmentText: {
      color: COLORS.gray.gray50,
      whiteSpace: 'nowrap',
      fontSize: theme.typography.pxToRem(12),
      marginLeft: theme.spacing(1),
    },
    bottomTextCounter: {
      marginTop: theme.spacing(1),
      marginLeft: 'auto',
      ...theme.typography.regular14,
      color: COLORS.gray.gray50,
      letterSpacing: 'normal',
    },
  }),
  { name: 'BriefTextField' }
);
